export default function Error() {
	return <h3>An error occurred</h3>;
}
